import React from 'react';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ColCondition, NumberField, SelectField } from '../../FinalForm';

const InternalSuppressionItem = ({ name }) => {
  const generateName = (field) => (name ? `${name}.${field}` : field);
  return (
    <>
      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
        <Grid size='grow'>
          <Typography variant='h6'>Suppression Item</Typography>
        </Grid>
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
        <Grid size='grow'>
          <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
            Type
          </FormLabel>
          <SelectField
            name={generateName('prePingSuppressionType')}
            options={[
              { value: null, option: 'none' },
              { value: 'days', option: 'days' },
              { value: 'hours', option: 'hours' },
              { value: 'minutes', option: 'minutes' },
            ]}
          />
        </Grid>
        <ColCondition when={generateName('prePingSuppressionType')}>
          <NumberField name={generateName('prePingSuppressionAmount')} label='Amount' />
        </ColCondition>
      </Grid>
      <br />
      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
        <ColCondition when={generateName('prePingSuppressionType')}>
          <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
            Level
          </FormLabel>
          <SelectField
            name={generateName('prePingSuppressionLevel')}
            options={[
              { value: null, option: 'select' },
              { value: 'none', option: 'none' },
              { value: 'calculated_revenue', option: 'calculated_revenue' },
              { value: 'accepted', option: 'accepted' },
              { value: 'impression', option: 'impression' },
            ]}
          />
        </ColCondition>
        <ColCondition when={generateName('prePingSuppressionType')}>
          <NumberField name={generateName('prePingSuppressionMaxLimit')} label='Max Limit' />
        </ColCondition>
      </Grid>
    </>
  );
};

export default InternalSuppressionItem;
